export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";
export const GET_ALL_CATEGORIES_FULFILLED = "GET_ALL_CATEGORIES_FULFILLED";
export const GET_ALL_CATEGORIES_PENDING = "GET_ALL_CATEGORIES_PENDING";
export const GET_ALL_CATEGORIES_REJECTED = "GET_ALL_CATEGORIES_REJECTED";

export const HANDLE_CATEGORIES_BACK_BUTTON = "HANDLE_CATEGORIES_BACK_BUTTON";
export const HANDLE_CATEGORIES_NAVIGATION = "HANDLE_CATEGORIES_NAVIGATION";
export const HANDLE_CATEGORIES_SELECTION = "HANDLE_CATEGORIES_SELECTION";
export const HANDLE_CATEGORIES_RESET = "HANDLE_CATEGORIES_RESET";
